import { ApiResponse, PaginatedResponse } from "../types/common";
import {
  Partner,
  CreatePartnerRequest,
  UpdatePartnerRequest,
  PartnerFilter,
} from "../types/landing";
import api from "./api";

// Partner CRUD Operations
export const partnerService = {
  getAllPartners: async (
    filters: PartnerFilter = {}
  ): Promise<PaginatedResponse<Partner>> => {
    try {
      const params = new URLSearchParams();

      if (filters.page) params.append("page", filters.page.toString());
      if (filters.limit) params.append("limit", filters.limit.toString());
      if (filters.status) params.append("status", filters.status);
      if (filters.type) params.append("type", filters.type);

      const response = await api.get(
        `/landing/partners/admin?${params.toString()}`
      );

      const data = response as any;
      return {
        success: data.success,
        data: data.data || [],
        pagination: data.pagination || {
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
          itemsPerPage: filters.limit || 10,
        },
      };
    } catch (error) {
      console.error("Error fetching partners:", error);
      throw error;
    }
  },

  getPartner: async (id: string): Promise<ApiResponse<Partner>> => {
    try {
      const response = await api.get(`/landing/partners/${id}`);
      return response as any;
    } catch (error) {
      console.error("Error fetching partner:", error);
      throw error;
    }
  },

  createPartner: async (
    partnerData: CreatePartnerRequest
  ): Promise<ApiResponse<Partner>> => {
    try {
      const response = await api.post("/landing/partners", partnerData);
      return response as any;
    } catch (error) {
      console.error("Error creating partner:", error);
      throw error;
    }
  },

  updatePartner: async (
    id: string,
    partnerData: UpdatePartnerRequest
  ): Promise<ApiResponse<Partner>> => {
    try {
      const response = await api.put(`/landing/partners/${id}`, partnerData);
      return response as any;
    } catch (error) {
      console.error("Error updating partner:", error);
      throw error;
    }
  },

  deletePartner: async (id: string): Promise<ApiResponse<null>> => {
    try {
      const response = await api.delete(`/landing/partners/${id}`);
      return response as any;
    } catch (error) {
      console.error("Error deleting partner:", error);
      throw error;
    }
  },

  activatePartner: async (id: string): Promise<ApiResponse<Partner>> => {
    try {
      const response = await api.patch(`/landing/partners/${id}/activate`);
      return response as any;
    } catch (error) {
      console.error("Error activating partner:", error);
      throw error;
    }
  },

  deactivatePartner: async (id: string): Promise<ApiResponse<Partner>> => {
    try {
      const response = await api.patch(`/landing/partners/${id}/deactivate`);
      return response as any;
    } catch (error) {
      console.error("Error deactivating partner:", error);
      throw error;
    }
  },

  updatePartnerOrder: async (
    id: string,
    displayOrder: number
  ): Promise<ApiResponse<Partner>> => {
    try {
      const response = await api.patch(`/landing/partners/${id}/order`, {
        displayOrder,
      });
      return response as any;
    } catch (error) {
      console.error("Error updating partner order:", error);
      throw error;
    }
  },
};
